import moment from 'moment';

function resolveOperationalMomentFromHHmm(
  hhmm: string,
  fetchKey: string, // "MMDDYYYY" for the displayed site-day
  shiftStart: string, // "HH:mm"
  timezone: string
) {
  const [h, m] = hhmm.split(':').map(Number);
  const [sh = 0, sm = 0] = (shiftStart || '00:00').split(':').map(Number);

  const base = moment.tz(fetchKey, 'MMDDYYYY', timezone).startOf('day');
  const shiftStartMoment = base.clone().add(sh, 'hours').add(sm, 'minutes');

  const candidate = base.clone().add(h, 'hours').add(m, 'minutes');
  // If time is before shift start, it belongs to the "next calendar day"
  if (candidate.isBefore(shiftStartMoment)) {
    candidate.add(1, 'day');
  }
  return candidate; // absolute moment in tz
}

export default resolveOperationalMomentFromHHmm;
